import { render, staticRenderFns } from "./ProductsCompensationCheckout.vue?vue&type=template&id=4b4fcfd7&"
import script from "./ProductsCompensationCheckout.vue?vue&type=script&lang=js&"
export * from "./ProductsCompensationCheckout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports